<template>
  <main>
    <div class="slider-area ">
      <div class="single-slider hero-overly slider-height2 d-flex align-items-center"
        v-if="blogtopo != '' && blogtopo[0].insInstitucionalImagens != ''"
        :style="{ backgroundImage: 'url(' + $imgURL + blogtopo[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '450px' }">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="hero-cap pt-60" style="text-align: center;">
                <h2 style="color:#fff;">{{ blogtopo[0].itiNome }}</h2>
                <!--nav aria-label="breadcrumb ">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/" style="color:#000000;">Home</router-link></li>
                    <li class="breadcrumb-item"><a href="#" style="color:#000000;">Blog</a></li>
                  </ol>
                </!--nav-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Blog section  -->
    <section class="blog_area section-padding">
      <div class="container">
          <div class="row">
            <div class="col-lg-12 mb-5 mb-lg-0" >
                  <button @click="goBack()" style="float: right;">Voltar</button>
                  <div class="blog_left_sidebar">
                    <article class="blog_item" v-if="detalhe != ''">
                      <h2 class="d-inline-block mt-2 mb-2">{{ detalhe.itiNome }}</h2>
                      <div class="blog_item_img">
                        <img v-if="detalhe.insInstitucionalImagens!=''" style="height:350px;width:auto" :src="$imgURL + detalhe.insInstitucionalImagens[0].itgUrlImagem" alt="">
                          <h3 class="blog_item_date">{{ formattedDate(detalhe.itiData1) }}</h3>
                      </div>
                      <div class="blog_details">
                        <p v-html="detalhe.itiResumo1"></p>
                      </div>
                    </article>
                  </div>
                </div>
            </div>
      </div>
    </section>
  
  </main>
</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import axios from 'axios'

export default {
  name: 'BlogDetalheView',
  setup() {
    const route = useRoute();
    const id = route.params.idBlog;
    return {
      id
   };
  },
  components: {
  },
  data: () => ({
    blogtopo: [],
    detalhe:[],
  }),
  methods: {
    carregaMetas(titlenews,value) {
			useHead({
				title: titlenews + ' - Blog Detalhe - Seleto Industrial Máquinas para Industria Alimentícia',
        meta: [
          { name: "description", content: value },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" }, 
          { charset: "UTF-8" }, 
          { name: "robots", content: "index, follow" }, 
        ],
			})
		},
    goBack(){
      this.$router.push("/blog");
    },
    formattedDate(value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Isso adicionará uma animação de rolagem suave
      });
    },
    isMobile() {
      return window.innerWidth <= 768; // Você pode ajustar esse valor de acordo com suas necessidades
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
  },
  },
  created() {

    axios.get('/Process/InsInstitucional/institucional/28/blogtopo')
      .then(response => {
        this.blogtopo = response.data;
      })
      .catch(error => {
        console.error(error);
      });

      axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
          this.detalhe = response.data
          this.carregaMetas(this.detalhe.itiNome, this.removerTagsHTML(this.detalhe.itiResumo1));
          console.log('detalhe')
          console.log(this.detalhe)
      })
      .catch(error => {
          console.error(error);
      });
   

  },
}
</script>

<style>
.das {
  display: block !important;
}

.slider-text h2 p {
  font-size: 60px;
  color: #081624;
  padding: 10px;
  display: inline-block;
  background: #99CC33;
  line-height: 1;
}</style>
